import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {CerbaAuthService} from "@digicerba/common";
import {IUserInformationsWebServiceClient} from "@common/resources/resources";

@Injectable()
export class AccessResolver implements Resolve<Boolean> {

  constructor(private iUserInformationsWebServiceClient: IUserInformationsWebServiceClient, private cerbaAuthService: CerbaAuthService) {
  }

  resolve() {
    let checkCall = this.iUserInformationsWebServiceClient.checkAccess();
    checkCall.subscribe(() => {
    }, (error) => {
      this.cerbaAuthService.unauthorized(error.status);
    });

    return checkCall;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/check.resolver.ts